// Assinaturas de user-agent de navegadores embutidos (in-app browser/WebView)
// de apps que não são identificados por `react-device-detect` como um
// Safari/Chrome comum e que costumam falhar ao abrir PDF (iframe ou nova
// aba) — ver docs/Diagnostico-Falha-Abertura-Contrato-Checkout.md, causa 1.
const IN_APP_BROWSER_SIGNATURES = [
  "FBAN",
  "FBAV",
  "Instagram",
  "WhatsApp",
  "Line",
  "MicroMessenger",
  "TikTok",
];

export function isInAppBrowser(userAgent: string | undefined | null): boolean {
  if (!userAgent) return false;
  return IN_APP_BROWSER_SIGNATURES.some((signature) => userAgent.includes(signature));
}
